import {
  SET_HEALTH_PLANS
} from './mutationTypes'

export const mutations = {
  [SET_HEALTH_PLANS]: (state, payload) => state.healthPlans = payload
}
